import React, { useContext, useEffect, useState } from "react";
import { SvgImages, PngImages } from "../../Utils/LocalImages";
import "../../assets/styles/style.css";
import { Link, useLocation } from "react-router-dom";
import Image from "../Reusable/Image";
import RoutesPath from "../../Utils/RoutesPath";
import { AuthContext } from "../../Context/authContext";

const Sidebar = () => {
  const [activeAccordion, setActiveAccordion] = useState(1);
  const [currentPath, setCurrentPath] = useState("");
  const { user } = useContext(AuthContext);

  const location = useLocation();
  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith(RoutesPath.classMaster)) {
      setActiveAccordion(1);
    } else if (path.startsWith(RoutesPath.subjectMaster)) {
      setActiveAccordion(2);
    } else if (
      path.startsWith(RoutesPath.viewStudyMaterial) ||
      path.startsWith(RoutesPath.addStudyMaterial) ||
      path.startsWith(RoutesPath.editStudyMaterial)
    ) {
      setActiveAccordion(3);
    } else if (
      path.startsWith(RoutesPath.viewQuestionBank) ||
      path.startsWith(RoutesPath.addQuestionBank) ||
      path.startsWith(RoutesPath.bulkUploadQuestions) ||
      path.startsWith(RoutesPath.editQuestionBank)
    ) {
      setActiveAccordion(4);
    } else if (
      path.startsWith(RoutesPath.blogcategory) ||
      path.startsWith(RoutesPath.addAuthors) ||
      path.startsWith(RoutesPath.authors) ||
      path.startsWith(RoutesPath.blog) ||
      path.startsWith(RoutesPath.viewBlog) ||
      path.startsWith(RoutesPath.editblog) ||
      path.startsWith(RoutesPath.editAuthors) ||
      path.startsWith(RoutesPath.seopage)
    ) {
      setActiveAccordion(5);
    } else if (
      path.startsWith(RoutesPath.addTestimonial) ||
      path.startsWith(RoutesPath.testimonial) ||
      path.startsWith(RoutesPath.editTestimonial)
    ) {
      setActiveAccordion(7);
    } else if (
      path.startsWith(RoutesPath.viewMockTest) ||
      path.startsWith(RoutesPath.addMockTest) ||
      path.startsWith(RoutesPath.editMockTest)
    ) {
      setActiveAccordion(8);
    } else if (
      path.startsWith(RoutesPath.faqCategory) ||
      path.startsWith(RoutesPath.addFaq) ||
      path.startsWith(RoutesPath.viewFaq) ||
      path.startsWith(RoutesPath.editFaq)
    ) {
      setActiveAccordion(9);
    } else if (
      path.startsWith(RoutesPath.addPackages) ||
      path.startsWith(RoutesPath.viewPackages) ||
      path.startsWith(RoutesPath.editPackages)
    ) {
      setActiveAccordion(10);
    } else if (
      path.startsWith(RoutesPath.contactList) ||
      path.startsWith(RoutesPath.socialMediaContact) ||
      path.startsWith(RoutesPath.privacyPolicy) ||
      path.startsWith(RoutesPath.termsandConditions) ||
      path.startsWith(RoutesPath.cancellationPolicy) ||
      path.startsWith(RoutesPath.aboutUs)
    ) {
      setActiveAccordion(11);
    } else if (path.startsWith(RoutesPath.updateSlider)) {
      setActiveAccordion(12);
    } else if (path.startsWith(RoutesPath.stateMaster)) {
      setActiveAccordion(13);
    } else if (path.startsWith(RoutesPath.districtMaster)) {
      setActiveAccordion(14);
    } else if (path.startsWith(RoutesPath.talukaMaster)) {
      setActiveAccordion(15);
    } else if (path.startsWith(RoutesPath.pincodeMaster)) {
      setActiveAccordion(16);
    } else if (
      path.startsWith(RoutesPath.viewCoordinator) ||
      path.startsWith(RoutesPath.commissionpercentage) ||
      path.startsWith(RoutesPath.coordinatorpayout) ||
      path.startsWith(RoutesPath.coordinatordetails) ||
      path.startsWith(RoutesPath.addCoordinator) ||
      path.startsWith(RoutesPath.editCoordinator)
    ) {
      setActiveAccordion(17);
    } else if (path.startsWith(RoutesPath.bharatsetexamlisting)) {
      setActiveAccordion(20);
    } else if (
      path.startsWith(RoutesPath.roleList) ||
      path.startsWith(RoutesPath.addsubadmin) ||
      path.startsWith(RoutesPath.subadminlist) ||
      path.startsWith(RoutesPath.setprivileges)
    ) {
      setActiveAccordion(19);
    } else if (
      path.startsWith(RoutesPath.registrationPageListing) ||
      path.startsWith(RoutesPath.editstudentdetails) ||
      path.startsWith(RoutesPath.coordinatorPageListing) ||
      path.startsWith(RoutesPath.bharatsetexamlisting) ||
      path.startsWith(RoutesPath.packagePurchasedListing)
    ) {
      setActiveAccordion(20);
    } else if (
      path.startsWith(RoutesPath.addexam) ||
      path.startsWith(RoutesPath.viewexam) ||
      path.startsWith(RoutesPath.editexam) || path.startsWith(RoutesPath.bharatSatQuestionsDetails) ||
      path.startsWith(RoutesPath.studentbatchlist)
    ) {
      setActiveAccordion(21);
    } else if (
      path.startsWith(RoutesPath.bharatsatexamresult)
      // path.startsWith(RoutesPath.viewexam) ||
      // path.startsWith(RoutesPath.editexam) || path.startsWith(RoutesPath.bharatSatQuestionsDetails)
    ) {
      setActiveAccordion(22);
    } else if (path.startsWith(RoutesPath.addbharatsetexam)) {
      setActiveAccordion(25);
    } else if (path.startsWith(RoutesPath.reveiwerquestionslist) || path.startsWith(RoutesPath.reviewerhistory) ||
      path.startsWith(RoutesPath.revieweraddquestionbank)) {
      setActiveAccordion(26);
    } else if (
      path.startsWith(RoutesPath.addshedulestudent) ||
      path.startsWith(RoutesPath.shedulestudent)
    ) {
      setActiveAccordion(22);
    } else if (
      path.startsWith(RoutesPath.addshedulestudentinterview) ||
      path.startsWith(RoutesPath.shedulestudentinterview)
    ) {
      setActiveAccordion(23);
    } else if (
      path.startsWith(RoutesPath.hallticket) ||
      path.startsWith(RoutesPath.listhallticket)
    ) {
      setActiveAccordion(24);
    }
    else if (
      path.startsWith(RoutesPath.addcoupans) ||
      path.startsWith(RoutesPath.coupanlisting) ||
      path.startsWith(RoutesPath.editcoupan)
    ) {
      setActiveAccordion(27);
    } else if (path.startsWith(RoutesPath.updatemobilebanner)) {
      setActiveAccordion(28);
    }
    else if (
      path.startsWith(RoutesPath.addStudents) ||
      path.startsWith(RoutesPath.editStudents) ||
      path.startsWith(RoutesPath.viewStudents) ||
      path.startsWith(RoutesPath.bulkUploadStudents)
    ) {
      setActiveAccordion(29);
    }

    else {
      setActiveAccordion(0);
    }

    setCurrentPath(location.pathname);
  }, [location.pathname, user]);

  return (
    <div className="sidebar d-flex flex-column overflow-auto ">
      <div className="logo mt-3 mb-5">
        <Link to={RoutesPath.classMaster}>
          <Image
            src={PngImages.DashboardLogo}
            className="img-fluid object-fit-contain"
            alt="Logo"
            style={{ height: "60px" }}
          />
        </Link>
      </div>

      {/* RolesList */}
      {user?.role_type === 0 ? (
        <>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.roleList}>
              <div
                className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${activeAccordion == 19
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(19);
                }}
              >
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Sub Admin
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 19
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 19
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.roleList}>
                  <h2
                    style={{
                      color:
                        currentPath?.startsWith(RoutesPath.roleList) ||
                          currentPath?.startsWith(RoutesPath.setprivileges)
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Role List
                  </h2>
                </Link>

                <Link to={RoutesPath.addsubadmin}>
                  <h2
                    style={{
                      color: currentPath?.startsWith(RoutesPath.addsubadmin)
                        ? "#F6821F"
                        : "#a8a8a8",
                    }}
                  >
                    Add Sub Admin
                  </h2>
                </Link>
                <Link to={RoutesPath.subadminlist}>
                  <h2
                    style={{
                      color: currentPath?.startsWith(RoutesPath.subadminlist)
                        ? "#F6821F"
                        : "#a8a8a8",
                    }}
                  >
                    Sub Admin List
                  </h2>
                </Link>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.classMaster}>
              <div
                className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 1
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(1);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Class Master
                  </h1>
                </div>
              </div>
            </Link>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.subjectMaster}>
              <div
                className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 2
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(2);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Subject Master
                  </h1>
                </div>
              </div>
            </Link>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.viewStudyMaterial}>
              <div
                className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 3
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(3);
                }}
              >
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon} />
                  <h1
                    className="white-space white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Study Material
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 3
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 3
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.addStudyMaterial}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.addStudyMaterial
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Add
                  </h2>
                </Link>

                <Link to={RoutesPath.viewStudyMaterial}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.viewStudyMaterial
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View
                  </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.viewQuestionBank}>
              <div
                className={`d-flex justify-content-between py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 4
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(4);
                }}
              >
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon} />
                  <h1
                    className="white-space  white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Question Bank
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 4
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 4
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.addQuestionBank}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.addQuestionBank
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Add
                  </h2>
                </Link>

                <Link to={RoutesPath.viewQuestionBank}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.viewQuestionBank
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View
                  </h2>
                </Link>

                <Link to={RoutesPath.bulkUploadQuestions}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.bulkUploadQuestions
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Bulk Upload
                  </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.viewBlog}>
              <div
                className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 5
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(5);
                }}
              >
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Blog
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 5
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 5
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.addAuthors}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.addAuthors
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Add Author
                  </h2>
                </Link>

                <Link to={RoutesPath.authors}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.authors
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View Author
                  </h2>
                </Link>
                <Link to={RoutesPath.blogcategory}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.blogcategory
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Blog Category
                  </h2>
                </Link>

                <Link to={RoutesPath.blog}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.blog ? "#F6821F" : "#a8a8a8",
                    }}
                  >
                    Add Blog
                  </h2>
                </Link>

                <Link to={RoutesPath.viewBlog}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.viewBlog
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View Blog
                  </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.testimonial}>
              <div
                className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 7
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(7);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Testimonial
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 7
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 7
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.addTestimonial}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.addTestimonial
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Add
                  </h2>
                </Link>

                <Link to={RoutesPath.testimonial}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.testimonial
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View
                  </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.viewMockTest}>
              <div
                className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${activeAccordion == 8
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(8);
                }}
              >
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Mock Test
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 8
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 8
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.addMockTest}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.addMockTest
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Add
                  </h2>
                </Link>

                <Link to={RoutesPath.viewMockTest}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.viewMockTest
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View
                  </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.faqCategory}>
              <div
                className={`d-flex justify-content-between py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 9
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(9);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    FAQ’s
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 9
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 9
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.faqCategory}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.faqCategory
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    FAQ’s Category
                  </h2>
                </Link>

                <Link to={RoutesPath.addFaq}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.addFaq
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Add
                  </h2>
                </Link>

                <Link to={RoutesPath.viewFaq}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.viewFaq
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View
                  </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.viewPackages}>
              <div
                className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${activeAccordion == 10
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(10);
                }}
              >
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Packages
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 10
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 10
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.addPackages}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.addPackages
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Add
                  </h2>
                </Link>

                <Link to={RoutesPath.viewPackages}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.viewPackages
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View
                  </h2>
                </Link>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.viewCoordinator}>
              <div
                className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${activeAccordion == 17
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(17);
                }}
              >
                <div className="d-flex gap-3">
                  <Image src={SvgImages.coordinatorrupees} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Coordinator
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 17
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 17
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.addCoordinator}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.addCoordinator
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Add
                  </h2>
                </Link>

                <Link to={RoutesPath.viewCoordinator}>
                  <h2
                    style={{
                      color:
                        currentPath?.startsWith(RoutesPath.viewCoordinator) ||
                          currentPath?.startsWith(
                            RoutesPath.commissionpercentage
                          ) ||
                          currentPath?.startsWith(RoutesPath.coordinatorpayout) ||
                          currentPath?.startsWith(RoutesPath.coordinatordetails)
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View
                  </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.registrationPageListing}>
              <div
                className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 20
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(20);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Reports
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 20
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 20
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.registrationPageListing}>
                  <h2
                    className="white-space-subtabs "
                    style={{
                      color:
                        currentPath?.startsWith(
                          RoutesPath.registrationPageListing
                        ) ||
                          currentPath?.startsWith(
                            RoutesPath.editstudentdetails
                          )
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Student Data Reports
                  </h2>
                </Link>
                <Link to={RoutesPath.coordinatorPageListing}>
                  <h2
                    className="white-space-subtabs "
                    style={{
                      color:
                        currentPath === RoutesPath.coordinatorPageListing
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Coordinator Data Reports
                  </h2>
                </Link>
                <Link to={RoutesPath.bharatsetexamlisting}>
                  <h2
                    className="white-space-subtabs "
                    style={{
                      color:
                        currentPath === RoutesPath.bharatsetexamlisting
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Bharat SAT Data Reports
                  </h2>
                </Link>
                <Link to={RoutesPath.packagePurchasedListing}>
                  <h2
                    className="white-space-subtabs "
                    style={{
                      color:
                        currentPath === RoutesPath.packagePurchasedListing
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Student Package Purchased
                  </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.contactList}>
              <div
                className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 11
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(11);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Dynamic
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 11
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 11
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.contactList}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.contactList
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Contacts
                  </h2>
                </Link>
                {/* <Link to={RoutesPath.registrationPageListing}>
                          <h2 className="white-space-subtabs "
                            style={{
                              color:
                                currentPath?.startsWith(RoutesPath.registrationPageListing) || currentPath?.startsWith(RoutesPath.registrationPageListingView)
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Registration Page Listing
                          </h2>
                        </Link>
                        <Link to={RoutesPath.coordinatorPageListing}>
                          <h2 className="white-space-subtabs "
                            style={{
                              color:
                                currentPath === RoutesPath.coordinatorPageListing
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Coordinator Page Listing
                          </h2>
                        </Link> */}
                <Link to={RoutesPath.socialMediaContact}>
                  <h2
                    className="white-space-subtabs "
                    style={{
                      color:
                        currentPath === RoutesPath.socialMediaContact
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Social Media & Contact Details
                  </h2>
                </Link>
                <Link to={RoutesPath.aboutUs}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.aboutUs
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    About Us
                  </h2>
                </Link>
                <Link to={RoutesPath.privacyPolicy}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.privacyPolicy
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Privacy policy
                  </h2>
                </Link>
                <Link to={RoutesPath.termsandConditions}>
                  <h2
                    className="white-space-subtabs "
                    style={{
                      color:
                        currentPath === RoutesPath.termsandConditions
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Terms and Conditions
                  </h2>
                </Link>
                <Link to={RoutesPath.cancellationPolicy}>
                  <h2
                    className="white-space-subtabs "
                    style={{
                      color:
                        currentPath === RoutesPath.cancellationPolicy
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Cancellation Policy
                  </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.updateSlider}>
              <div
                className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 12
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(12);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Update Slider
                  </h1>
                </div>
              </div>
            </Link>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.updatemobilebanner}>
              <div
                className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 28
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(28);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Update Mobile Banners
                  </h1>
                </div>
              </div>
            </Link>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.stateMaster}>
              <div
                className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 13
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(13);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    State Master
                  </h1>
                </div>
              </div>
            </Link>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.districtMaster}>
              <div
                className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 14
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(14);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    District Master
                  </h1>
                </div>
              </div>
            </Link>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.talukaMaster}>
              <div
                className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 15
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(15);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Taluka Master
                  </h1>
                </div>
              </div>
            </Link>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.pincodeMaster}>
              <div
                className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 16
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(16);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Pincode Master
                  </h1>
                </div>
              </div>
            </Link>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.coupanlisting}>
              <div
                className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${activeAccordion == 27
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(27);
                }}
              >
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Coupon
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 27
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 27
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">

                <Link to={RoutesPath.addcoupans}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.addcoupans
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Add
                  </h2>
                </Link>


                <Link to={RoutesPath.coupanlisting}>
                  <h2
                    style={{
                      color:
                        currentPath?.startsWith(
                          RoutesPath.coupanlisting
                        )
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View
                  </h2>
                </Link>
              </div>
            </div>
          </div>

          {/* Students */}

          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.viewStudents}>
              <div
                className={`d-flex justify-content-between py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 29
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(29);
                }}
              >
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon} />
                  <h1
                    className="white-space  white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Students
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 29
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 29
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                <Link to={RoutesPath.addStudents}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.addStudents
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Add
                  </h2>
                </Link>

                <Link to={RoutesPath.viewStudents}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.viewStudents
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View
                  </h2>
                </Link>

                <Link to={RoutesPath.bulkUploadStudents}>
                  <h2
                    style={{
                      color:
                        currentPath === RoutesPath.bulkUploadStudents
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    Bulk Upload
                  </h2>
                </Link>
              </div>
            </div>
          </div>



          <div className="d-flex flex-column ps-4 mb-3">
            <div className="d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ">
              {" "}
              <div className="d-flex gap-3">
                <h1
                  className="white fs-16 fw-500 mb-0"
                  style={{ marginTop: 1, color: "#F6821F" }}
                >
                  Bharat SAT
                </h1>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.viewexam}>
              <div
                className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 21
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(21);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Create Exam
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 21
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 21
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                {
                  <Link to={RoutesPath.addexam}>
                    <h2
                      style={{
                        color:
                          currentPath === RoutesPath.addexam
                            ? "#F6821F"
                            : "#a8a8a8",
                      }}
                    >
                      Add
                    </h2>
                  </Link>
                }

                <Link to={RoutesPath.viewexam}>
                  <h2
                    style={{
                      color:
                        currentPath?.startsWith(RoutesPath.viewexam) ||
                          currentPath?.startsWith(
                            RoutesPath.bharatSatQuestionsDetails
                          ) ||
                          currentPath?.startsWith(RoutesPath.editexam) || currentPath?.startsWith(RoutesPath.studentbatchlist)
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    View
                  </h2>
                </Link>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.bharatsatexamresult}>
              <div
                className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 22
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(22);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon_two} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    View Result
                  </h1>
                </div>
              </div>
            </Link>
          </div>

          {/* //Reviewer */}
          <div className="d-flex flex-column ps-4 mb-3">
            <Link to={RoutesPath.reveiwerquestionslist}>
              <div
                className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 26
                  ? "accordianHeaderActive"
                  : "accordianHeaderInactive"
                  }`}
                onClick={() => {
                  setActiveAccordion(26);
                }}
              >
                {" "}
                <div className="d-flex gap-3">
                  <Image src={SvgImages.menu_icon} />
                  <h1
                    className="white fs-16 fw-500 mb-0"
                    style={{ marginTop: 1 }}
                  >
                    Reviewer
                  </h1>
                </div>
                <Image
                  src={SvgImages.up_down_arrow}
                  className={`${activeAccordion == 26
                    ? "accordianArrowInvert"
                    : "accordianArrow"
                    }`}
                />
              </div>
            </Link>
            <div
              className={`accordion-body p-0 ms-4 ${activeAccordion == 26
                ? "accordiaBodyActive"
                : "accordiaBodyInactive"
                }`}
            >
              <div className="selectSection select_option">
                {
                  <Link to={RoutesPath.reveiwerquestionslist}>
                    <h2
                      style={{
                        color:
                          currentPath?.startsWith(RoutesPath.revieweraddquestionbank) ||
                            currentPath?.startsWith(RoutesPath.reveiwerquestionslist)
                            ? "#F6821F"
                            : "#a8a8a8",
                      }}
                    >
                      Questions List
                    </h2>
                  </Link>
                }

                <Link to={RoutesPath.reviewerhistory}>
                  <h2
                    style={{
                      color:
                        // currentPath?.startsWith(RoutesPath.reviewerhistory) ||
                        // currentPath?.startsWith(
                        //   RoutesPath.bharatSatQuestionsDetails
                        // ) ||
                        currentPath?.startsWith(RoutesPath.reviewerhistory)
                          ? "#F6821F"
                          : "#a8a8a8",
                    }}
                  >
                    History
                  </h2>
                </Link>
              </div>
            </div>
          </div>
        </>
      ) : (
        user?.setPrivileges?.map((item) => {
          return (
            <>
              {item?.read === true && item?.parameter == "Class Master" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.classMaster}>
                    <div
                      className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 1
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(1);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Class Master
                        </h1>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : null}

              {item?.read === true && item?.parameter === "Subject Master" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.subjectMaster}>
                    <div
                      className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 2
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(2);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Subject Master
                        </h1>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : null}
              {item?.read === true && item?.parameter === "Study material" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.viewStudyMaterial}>
                    <div
                      className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 3
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(3);
                      }}
                    >
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon} />
                        <h1
                          className="white-space white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Study Material
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 3
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 3
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      {item?.create === true &&
                        item?.parameter === "Study material" ? (
                        <Link to={RoutesPath.addStudyMaterial}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.addStudyMaterial
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add
                          </h2>
                        </Link>
                      ) : null}

                      <Link to={RoutesPath.viewStudyMaterial}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.viewStudyMaterial
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          View
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}
              {item?.read === true && item?.parameter === "Question Bank" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.viewQuestionBank}>
                    <div
                      className={`d-flex justify-content-between py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 4
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(4);
                      }}
                    >
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon} />
                        <h1
                          className="white-space  white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Question Bank
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 4
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 4
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      {item?.create === true &&
                        item?.parameter === "Question Bank" ? (
                        <Link to={RoutesPath.addQuestionBank}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.addQuestionBank
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add
                          </h2>
                        </Link>
                      ) : null}

                      <Link to={RoutesPath.viewQuestionBank}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.viewQuestionBank
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          View
                        </h2>
                      </Link>

                      <Link to={RoutesPath.bulkUploadQuestions}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.bulkUploadQuestions
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Bulk Upload
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}
              {item?.read === true && item?.parameter === "Blogs" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.viewBlog}>
                    <div
                      className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 5
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(5);
                      }}
                    >
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Blog
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 5
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 5
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      {item?.create === true && item?.parameter === "Blogs" ? (
                        <Link to={RoutesPath.addAuthors}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.addAuthors
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add Author
                          </h2>
                        </Link>
                      ) : null}
                      <Link to={RoutesPath.authors}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.authors
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          View Author
                        </h2>
                      </Link>
                      <Link to={RoutesPath.blogcategory}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.blogcategory
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Blog Category
                        </h2>
                      </Link>
                      {item?.create === true && item?.parameter === "Blogs" ? (
                        <Link to={RoutesPath.blog}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.blog
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add Blog
                          </h2>
                        </Link>
                      ) : null}
                      <Link to={RoutesPath.viewBlog}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.viewBlog
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          View Blog
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}

              {item?.read === true && item?.parameter === "Testimonials" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.testimonial}>
                    <div
                      className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 7
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(7);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Testimonial
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 7
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 7
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      {item?.create === true &&
                        item?.parameter === "Testimonials" ? (
                        <Link to={RoutesPath.addTestimonial}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.addTestimonial
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add
                          </h2>
                        </Link>
                      ) : null}

                      <Link to={RoutesPath.testimonial}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.testimonial
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          View
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}

              {item?.read === true && item?.parameter === "Mock Test" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.viewMockTest}>
                    <div
                      className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${activeAccordion == 8
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(8);
                      }}
                    >
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Mock Test
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 8
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 8
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      {item?.create === true &&
                        item?.parameter === "Mock Test" ? (
                        <Link to={RoutesPath.addMockTest}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.addMockTest
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add
                          </h2>
                        </Link>
                      ) : null}

                      <Link to={RoutesPath.viewMockTest}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.viewMockTest
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          View
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}

              {item?.read === true && item?.parameter === "Faq's" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.faqCategory}>
                    <div
                      className={`d-flex justify-content-between py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 9
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(9);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          FAQ’s
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 9
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 9
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      <Link to={RoutesPath.faqCategory}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.faqCategory
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          FAQ’s Category
                        </h2>
                      </Link>
                      {item?.create === true && item?.parameter === "Faq's" ? (
                        <Link to={RoutesPath.addFaq}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.addFaq
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add
                          </h2>
                        </Link>
                      ) : null}
                      <Link to={RoutesPath.viewFaq}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.viewFaq
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          View
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}

              {item?.read === true && item?.parameter === "Packages" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.viewPackages}>
                    <div
                      className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${activeAccordion == 10
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(10);
                      }}
                    >
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Packages
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 10
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 10
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      {item?.create === true &&
                        item?.parameter === "Packages" ? (
                        <Link to={RoutesPath.addPackages}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.addPackages
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add
                          </h2>
                        </Link>
                      ) : null}
                      <Link to={RoutesPath.viewPackages}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.viewPackages
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          View
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}

              {/* {
                  item?.read === true && item?.parameter === "Bharat Sat Exam" ?
                    <div className="d-flex flex-column ps-4 mb-3">
                      <Link to={RoutesPath.bharatsetexamlisting}>
                        <div
                          className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${activeAccordion == 18
                            ? "accordianHeaderActive"
                            : "accordianHeaderInactive"
                            }`}
                          onClick={() => {
                            setActiveAccordion(18);
                          }}
                        >
                          <div className="d-flex gap-3">
                            <Image src={SvgImages.menu_icon_two} />
                            <h1 className="white fs-16 fw-500 mb-0" style={{ marginTop: 1 }}>
                              Bharat SAT
                            </h1>
                          </div>
                        </div>
                      </Link>
  
                    </div>
                    : null
                } */}

              {item?.read === true && item?.parameter === "Coordinator" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.viewCoordinator}>
                    <div
                      className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${activeAccordion == 17
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(17);
                      }}
                    >
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.coordinatorrupees} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Coordinator
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 17
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 17
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      {item?.create === true &&
                        item?.parameter === "Coordinator" ? (
                        <Link to={RoutesPath.addCoordinator}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.addCoordinator
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add
                          </h2>
                        </Link>
                      ) : null}

                      <Link to={RoutesPath.viewCoordinator}>
                        <h2
                          style={{
                            color:
                              currentPath?.startsWith(
                                RoutesPath.viewCoordinator
                              ) ||
                                currentPath?.startsWith(
                                  RoutesPath.commissionpercentage
                                ) ||
                                currentPath?.startsWith(
                                  RoutesPath.coordinatorpayout
                                ) ||
                                currentPath?.startsWith(
                                  RoutesPath.coordinatordetails
                                )
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          View
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}

              {/* Reports */}

              {item?.read === true && item?.parameter === "Reports" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.registrationPageListing}>
                    <div
                      className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 20
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(20);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Reports
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 20
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 20
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      <Link to={RoutesPath.registrationPageListing}>
                        <h2
                          className="white-space-subtabs "
                          style={{
                            color:
                              currentPath?.startsWith(
                                RoutesPath.registrationPageListing
                              ) ||
                                currentPath?.startsWith(
                                  RoutesPath.editstudentdetails
                                )
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Student Data Reports
                        </h2>
                      </Link>
                      <Link to={RoutesPath.coordinatorPageListing}>
                        <h2
                          className="white-space-subtabs "
                          style={{
                            color:
                              currentPath === RoutesPath.coordinatorPageListing
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Coordinator Data Reports
                        </h2>
                      </Link>
                      <Link to={RoutesPath.bharatsetexamlisting}>
                        <h2
                          className="white-space-subtabs "
                          style={{
                            color:
                              currentPath === RoutesPath.bharatsetexamlisting
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Bharat SAT Data Reports
                        </h2>
                      </Link>
                      <Link to={RoutesPath.packagePurchasedListing}>
                        <h2
                          className="white-space-subtabs "
                          style={{
                            color:
                              currentPath === RoutesPath.packagePurchasedListing
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Student Package Purchased
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}

              {item?.read === true && item?.parameter === "Dynamic" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.contactList}>
                    <div
                      className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 11
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(11);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Dynamic
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 11
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 11
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      <Link to={RoutesPath.contactList}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.contactList
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Contacts
                        </h2>
                      </Link>
                      {/* <Link to={RoutesPath.registrationPageListing}>
                            <h2 className="white-space-subtabs "
                              style={{
                                color:
                                  currentPath?.startsWith(RoutesPath.registrationPageListing) || currentPath?.startsWith(RoutesPath.registrationPageListingView)
                                    ? "#F6821F"
                                    : "#a8a8a8",
                              }}
                            >
                              Registration Page Listing
                            </h2>
                          </Link>
                          <Link to={RoutesPath.coordinatorPageListing}>
                            <h2 className="white-space-subtabs "
                              style={{
                                color:
                                  currentPath === RoutesPath.coordinatorPageListing
                                    ? "#F6821F"
                                    : "#a8a8a8",
                              }}
                            >
                              Coordinator Page Listing
                            </h2>
                          </Link> */}
                      <Link to={RoutesPath.socialMediaContact}>
                        <h2
                          className="white-space-subtabs "
                          style={{
                            color:
                              currentPath === RoutesPath.socialMediaContact
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Social Media & Contact Details
                        </h2>
                      </Link>
                      <Link to={RoutesPath.aboutUs}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.aboutUs
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          About Us
                        </h2>
                      </Link>
                      <Link to={RoutesPath.privacyPolicy}>
                        <h2
                          style={{
                            color:
                              currentPath === RoutesPath.privacyPolicy
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Privacy policy
                        </h2>
                      </Link>
                      <Link to={RoutesPath.termsandConditions}>
                        <h2
                          className="white-space-subtabs "
                          style={{
                            color:
                              currentPath === RoutesPath.termsandConditions
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Terms and Conditions
                        </h2>
                      </Link>
                      <Link to={RoutesPath.cancellationPolicy}>
                        <h2
                          className="white-space-subtabs "
                          style={{
                            color:
                              currentPath === RoutesPath.cancellationPolicy
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          Cancellation Policy
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}

              {item?.read === true && item?.parameter === "Updateslider" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.updateSlider}>
                    <div
                      className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 12
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(12);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Update Slider
                        </h1>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : null}
              {item?.read === true && item?.parameter === "Updateslider" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.updatemobilebanner}>
                    <div
                      className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 28
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(28);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Update Slider
                        </h1>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : null}

              {item?.read === true && item?.parameter === "State Master" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.stateMaster}>
                    <div
                      className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 13
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(13);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          State Master
                        </h1>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : null}
              {/* District Master */}
              {item?.read === true && item?.parameter === "District Master" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.districtMaster}>
                    <div
                      className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 14
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(14);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          District Master
                        </h1>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : null}

              {/* Taluka Master */}
              {item?.read === true && item?.parameter === "Taluka Master" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.talukaMaster}>
                    <div
                      className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 15
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(15);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Taluka Master
                        </h1>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : null}

              {/* PinCode Master */}
              {item?.read === true && item?.parameter === "Pincode Master" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.pincodeMaster}>
                    <div
                      className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 16
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(16);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon_two} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Pincode Master
                        </h1>
                      </div>
                    </div>
                  </Link>
                </div>
              ) : null}

              {item?.read === true && item?.parameter === "Coupon" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.coupanlisting}>
                    <div
                      className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${activeAccordion == 27
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(27);
                      }}
                    >
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.coordinatorrupees} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Coupon
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 27
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 27
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      {item?.create === true &&
                        item?.parameter === "Coupon" ? (
                        <Link to={RoutesPath.addcoupans}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.addcoupans
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add
                          </h2>
                        </Link>
                      ) : null}

                      <Link to={RoutesPath.coupanlisting}>
                        <h2
                          style={{
                            color:
                              currentPath?.startsWith(
                                RoutesPath.coupanlisting
                              )
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          View
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null}

              {
                item?.read === true && item?.parameter === "Students" ? (
                  <div className="d-flex flex-column ps-4 mb-3">
                    <Link to={RoutesPath.viewStudents}>
                      <div
                        className={`d-flex justify-content-between py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 29
                          ? "accordianHeaderActive"
                          : "accordianHeaderInactive"
                          }`}
                        onClick={() => {
                          setActiveAccordion(29);
                        }}
                      >
                        <div className="d-flex gap-3">
                          <Image src={SvgImages.menu_icon} />
                          <h1
                            className="white-space  white fs-16 fw-500 mb-0"
                            style={{ marginTop: 1 }}
                          >
                            Students
                          </h1>
                        </div>
                        <Image
                          src={SvgImages.up_down_arrow}
                          className={`${activeAccordion == 29
                            ? "accordianArrowInvert"
                            : "accordianArrow"
                            }`}
                        />
                      </div>
                    </Link>
                    <div
                      className={`accordion-body p-0 ms-4 ${activeAccordion == 29
                        ? "accordiaBodyActive"
                        : "accordiaBodyInactive"
                        }`}
                    >
                      <div className="selectSection select_option">
                        <Link to={RoutesPath.addStudents}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.addStudents
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Add
                          </h2>
                        </Link>

                        <Link to={RoutesPath.viewStudents}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.viewStudents
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            View
                          </h2>
                        </Link>

                        <Link to={RoutesPath.bulkUploadStudents}>
                          <h2
                            style={{
                              color:
                                currentPath === RoutesPath.bulkUploadStudents
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Bulk Upload
                          </h2>
                        </Link>
                      </div>
                    </div>
                  </div>
                ) : null
              }
              {item.read === true && item?.parameter === "Bharat Sat Exam" ? (
                <>
                  <div className="d-flex flex-column ps-4 mb-3">
                    <div className="d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ">
                      {" "}
                      <div className="d-flex gap-3">
                        <h1
                          className="white fs-16 fw-500 mb-0 "
                          style={{ marginTop: 1, color: "#F6821F" }}
                        >
                          Bharat SAT
                        </h1>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column ps-4 mb-3">
                    <Link to={RoutesPath.viewexam}>
                      <div
                        className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 21
                          ? "accordianHeaderActive"
                          : "accordianHeaderInactive"
                          }`}
                        onClick={() => {
                          setActiveAccordion(21);
                        }}
                      >
                        {" "}
                        <div className="d-flex gap-3">
                          <Image src={SvgImages.menu_icon} />
                          <h1
                            className="white fs-16 fw-500 mb-0"
                            style={{ marginTop: 1 }}
                          >
                            Create Exam
                          </h1>
                        </div>
                        <Image
                          src={SvgImages.up_down_arrow}
                          className={`${activeAccordion == 21
                            ? "accordianArrowInvert"
                            : "accordianArrow"
                            }`}
                        />
                      </div>
                    </Link>
                    <div
                      className={`accordion-body p-0 ms-4 ${activeAccordion == 21
                        ? "accordiaBodyActive"
                        : "accordiaBodyInactive"
                        }`}
                    >
                      <div className="selectSection select_option">
                        {
                          (item?.create === true) && (item?.parameter === "Bharat Sat Exam") ?
                            <Link to={RoutesPath.addexam}>
                              <h2
                                style={{
                                  color:
                                    currentPath === RoutesPath.addexam
                                      ? "#F6821F"
                                      : "#a8a8a8",
                                }}
                              >
                                Add
                              </h2>
                            </Link>
                            : null
                        }

                        <Link to={RoutesPath.viewexam}>
                          <h2
                            style={{
                              color:
                                currentPath?.startsWith(RoutesPath.viewexam) ||
                                  currentPath?.startsWith(
                                    RoutesPath.bharatSatQuestionsDetails
                                  ) ||
                                  currentPath?.startsWith(RoutesPath.editexam)
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            View
                          </h2>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column ps-4 mb-3">
                    <Link to={RoutesPath.bharatsatexamresult}>
                      <div
                        className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${activeAccordion == 22
                          ? "accordianHeaderActive"
                          : "accordianHeaderInactive"
                          }`}
                        onClick={() => {
                          setActiveAccordion(22);
                        }}
                      >
                        {" "}
                        <div className="d-flex gap-3">
                          <Image src={SvgImages.menu_icon_two} />
                          <h1
                            className="white fs-16 fw-500 mb-0"
                            style={{ marginTop: 1 }}
                          >
                            View Result
                          </h1>
                        </div>
                      </div>
                    </Link>
                  </div>

                  {/* Reveiwer */}

                </>
              ) : null}


              {item?.read === true && item?.parameter === "Reviewer" ? (
                <div className="d-flex flex-column ps-4 mb-3">
                  <Link to={RoutesPath.reveiwerquestionslist}>
                    <div
                      className={`d-flex justify-content-between py-3 ps-3 pe-3  align-items-center accordianHeader ${activeAccordion == 26
                        ? "accordianHeaderActive"
                        : "accordianHeaderInactive"
                        }`}
                      onClick={() => {
                        setActiveAccordion(26);
                      }}
                    >
                      {" "}
                      <div className="d-flex gap-3">
                        <Image src={SvgImages.menu_icon} />
                        <h1
                          className="white fs-16 fw-500 mb-0"
                          style={{ marginTop: 1 }}
                        >
                          Reviewer
                        </h1>
                      </div>
                      <Image
                        src={SvgImages.up_down_arrow}
                        className={`${activeAccordion == 26
                          ? "accordianArrowInvert"
                          : "accordianArrow"
                          }`}
                      />
                    </div>
                  </Link>
                  <div
                    className={`accordion-body p-0 ms-4 ${activeAccordion == 26
                      ? "accordiaBodyActive"
                      : "accordiaBodyInactive"
                      }`}
                  >
                    <div className="selectSection select_option">
                      {
                        <Link to={RoutesPath.reveiwerquestionslist}>
                          <h2
                            style={{
                              color:
                                currentPath?.startsWith(RoutesPath.revieweraddquestionbank) ||
                                  currentPath?.startsWith(RoutesPath.reveiwerquestionslist)
                                  ? "#F6821F"
                                  : "#a8a8a8",
                            }}
                          >
                            Questions List
                          </h2>
                        </Link>
                      }

                      <Link to={RoutesPath.reviewerhistory}>
                        <h2
                          style={{
                            color:
                              // currentPath?.startsWith(RoutesPath.reviewerhistory) ||
                              // currentPath?.startsWith(
                              //   RoutesPath.bharatSatQuestionsDetails
                              // ) ||
                              currentPath?.startsWith(RoutesPath.reviewerhistory)
                                ? "#F6821F"
                                : "#a8a8a8",
                          }}
                        >
                          History
                        </h2>
                      </Link>
                    </div>
                  </div>
                </div>) : null}
            </>
          );
        })
      )}

      {/* <div className="d-flex flex-column ps-4 mb-3">
        <Link to={RoutesPath.bharatsetresult}>
          <div
            className={`d-flex gap-3 py-3 ps-3 pe-3 align-items-center accordianHeader ${
              activeAccordion == 21
                ? "accordianHeaderActive"
                : "accordianHeaderInactive"
            }`}
            onClick={() => {
              setActiveAccordion(21);
            }}
          >
            {" "}
            <div className="d-flex gap-3">
              <Image src={SvgImages.menu_icon_two} />
              <h1 className="white fs-16 fw-500 mb-0" style={{ marginTop: 1 }}>
                Bharat SAT Results
              </h1>
            </div>
          </div>
        </Link>
      </div> */}

      {/* <div className="d-flex flex-column ps-4 mb-3">
        <Link to={RoutesPath.shedulestudent}>
          <div
            className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${
              activeAccordion == 22
                ? "accordianHeaderActive"
                : "accordianHeaderInactive"
            }`}
            onClick={() => {
              setActiveAccordion(22);
            }}
          >
            <div className="d-flex gap-3">
              <Image src={SvgImages.menu_icon_two} />
              <h1 className="white fs-16 fw-500 mb-0" style={{ marginTop: 1 }}>
                Schedule Student Batch
              </h1>
            </div>
            <Image
              src={SvgImages.up_down_arrow}
              className={`${
                activeAccordion == 22
                  ? "accordianArrowInvert"
                  : "accordianArrow"
              }`}
            />
          </div>
        </Link>
        <div
          className={`accordion-body p-0 ms-4 ${
            activeAccordion == 22
              ? "accordiaBodyActive"
              : "accordiaBodyInactive"
          }`}
        >
          <div className="selectSection select_option">
          
            <Link to={RoutesPath.addshedulestudent}>
              <h2
                style={{
                  color:
                    currentPath === RoutesPath.addshedulestudent
                      ? "#F6821F"
                      : "#a8a8a8",
                }}
              >
                Add
              </h2>
            </Link>
       

            <Link to={RoutesPath.shedulestudent}>
              <h2
                style={{
                  color:
                    currentPath === RoutesPath.shedulestudent
                      ? "#F6821F"
                      : "#a8a8a8",
                }}
              >
                View
              </h2>
            </Link>
          </div>
        </div>
      </div> */}
      {/* <div className="d-flex flex-column ps-4 mb-3">
        <Link to={RoutesPath.shedulestudentinterview}>
          <div
            className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${
              activeAccordion == 23
                ? "accordianHeaderActive"
                : "accordianHeaderInactive"
            }`}
            onClick={() => {
              setActiveAccordion(23);
            }}
          >
            <div className="d-flex gap-3">
              <Image src={SvgImages.menu_icon_two} />
              <h1 className="white fs-16 fw-500 mb-0" style={{ marginTop: 1 }}>
                Schedule Interview
              </h1>
            </div>
            <Image
              src={SvgImages.up_down_arrow}
              className={`${
                activeAccordion == 23
                  ? "accordianArrowInvert"
                  : "accordianArrow"
              }`}
            />
          </div>
        </Link>
        <div
          className={`accordion-body p-0 ms-4 ${
            activeAccordion == 23
              ? "accordiaBodyActive"
              : "accordiaBodyInactive"
          }`}
        >
          <div className="selectSection select_option">
           
            <Link to={RoutesPath.addshedulestudentinterview}>
              <h2
                style={{
                  color:
                    currentPath === RoutesPath.addshedulestudentinterview
                      ? "#F6821F"
                      : "#a8a8a8",
                }}
              >
                Add
              </h2>
            </Link>
          

            <Link to={RoutesPath.shedulestudentinterview}>
              <h2
                style={{
                  color:
                    currentPath === RoutesPath.shedulestudentinterview
                      ? "#F6821F"
                      : "#a8a8a8",
                }}
              >
                View
              </h2>
            </Link>
          </div>
        </div>
      </div>

      <div className="d-flex flex-column ps-4 mb-3">
        <Link to={RoutesPath.hallticket}>
          <div
            className={`d-flex  justify-content-between py-3 ps-3 pe-3 gap_12 align-items-center accordianHeader ${
              activeAccordion == 24
                ? "accordianHeaderActive"
                : "accordianHeaderInactive"
            }`}
            onClick={() => {
              setActiveAccordion(24);
            }}
          >
            <div className="d-flex gap-3">
              <Image src={SvgImages.menu_icon_two} />
              <h1 className="white fs-16 fw-500 mb-0" style={{ marginTop: 1 }}>
                Generate E-Hall Ticket
              </h1>
            </div>
            <Image
              src={SvgImages.up_down_arrow}
              className={`${
                activeAccordion == 24
                  ? "accordianArrowInvert"
                  : "accordianArrow"
              }`}
            />
          </div>
        </Link>
        <div
          className={`accordion-body p-0 ms-4 ${
            activeAccordion == 24
              ? "accordiaBodyActive"
              : "accordiaBodyInactive"
          }`}
        >
          <div className="selectSection select_option">
         
            <Link to={RoutesPath.hallticket}>
              <h2
                style={{
                  color:
                    currentPath === RoutesPath.hallticket
                      ? "#F6821F"
                      : "#a8a8a8",
                }}
              >
                Add
              </h2>
            </Link>
           

            <Link to={RoutesPath.listhallticket}>
              <h2
                style={{
                  color:
                    currentPath === RoutesPath.listhallticket
                      ? "#F6821F"
                      : "#a8a8a8",
                }}
              >
                View
              </h2>
            </Link>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Sidebar;
